
<div class="lineItem" *ngFor="let product of lineItems; let i= index">
        <vs-quote-tracking-product
        [product]="product"
        [productOpen]="expandAll"
        [index]="i"
        ></vs-quote-tracking-product>
</div>    
